export default __webpack_public_path__ + "static/media/mba-1.42e5c465.jpg";